import { useRef, useEffect } from 'react';
import { IGuideComponent } from '@apps/i-guide';
import { useScrollIntoViewOnNavigation } from '@pm2/react-utils';
import { useComponentFrameworkAutoDeactivation, componentFrameworkStore } from '@provider/component-framework';
import { useLocation } from '@provider/navigation';
import { useClickOutsideListener } from '@utils/react';
import { contentTransitionDurationMs } from './comp.router.style.js';
import { jsx } from 'react/jsx-runtime';

function EmbedContent(props) {
  const ref = useRef(null);
  const isTransitioningBetweenPagesRef = useTransitionState();
  useScrollIntoViewOnNavigation(props.rootRef);
  useComponentFrameworkAutoDeactivation(props.rootRef, {
    componentId: props.component.envelope.ID,
    isDisabledRef: isTransitioningBetweenPagesRef,
    onDeactivate: props.onDeactivate
  });
  useClickOutsideListener(() => {
    componentFrameworkStore.dispatch(componentFrameworkStore.actions.deactivateComponent(props.component.envelope.ID));
    props.onDeactivate();
  }, ref);
  return /*#__PURE__*/jsx(IGuideComponent, {
    ref: ref,
    context: "embedded",
    component: props.component,
    onActivate: props.onActivate,
    onShareWithTeacher: props.onShareWithTeacher,
    onCollapse: props.onCollapse,
    onResetEntry: props.onResetEntry,
    node: props.node
  });
}
function useTransitionState() {
  const location = useLocation();
  const isTransitioningRef = useRef(false);
  useEffect(() => {
    isTransitioningRef.current = true;
    const timeoutId = setTimeout(() => {
      isTransitioningRef.current = false;
    }, contentTransitionDurationMs);
    return () => {
      window.clearTimeout(timeoutId);
    };
  }, [location.asPath]);
  return isTransitioningRef;
}

export { EmbedContent };
//# sourceMappingURL=comp.embed-integration.js.map
